"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PriceSvg;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _svgs = require("svgs");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utilities = require("@sart/utilities");
var _excluded = ["value", "currency", "style"]; // import { colors } from '@sart/styles'
function PriceSvg(props) {
  var value = props.value,
    currency = props.currency,
    style = props.style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var formated = (0, _utilities.formatCurrencyToString)(value, currency);
  return /*#__PURE__*/_react["default"].createElement(_svgs.Text, rest, formated);
}
PriceSvg.defaultProps = {
  value: 0
};
var PropTypesCurrencyShape = _propTypes["default"].shape({
  code: _propTypes["default"].string,
  countries: _propTypes["default"].arrayOf(_propTypes["default"].string),
  currency: _propTypes["default"].string,
  precision: _propTypes["default"].number,
  format: _propTypes["default"].string,
  number: _propTypes["default"].string,
  symbol: _propTypes["default"].string
});
PriceSvg.propTypes = {
  value: _propTypes["default"].number.isRequired,
  currency: PropTypesCurrencyShape
};